module.exports = __webpack_public_path__ + "img/expostyle_1496_champagne_pantone151218tpg.ce7c5a0c.jpg";